import { render, staticRenderFns } from "./JsonView.vue?vue&type=template&id=4934b67f&"
import script from "./JsonView.vue?vue&type=script&lang=ts&"
export * from "./JsonView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports